<template>
  <template-info
    :bgImg="bgImg"
    title="ข้อกำหนดการใช้งาน"
    @actionClickBack="goBack"
  >
    <div>
      <div class="content-title">
        ผลิตภัณฑ์การให้ความรู้ทางภาษีแบบดิจิทัล ({{ getHostUrl() }})
        ได้รับการพัฒนาขึ้นโดยความร่วมมือระหว่างกรม สรรพากร กระทรวงการคลัง
        และธนาคารพัฒนา เอเชีย (Asian Development Bank)
        ภายใต้โครงการความช่วยเหลือทางวิชาการ เรื่อง ‘Specialized and Semi-Formal
        Financial Institutions to Support Financial Inclusion’
        โดยได้รับการสนับสนุนทางการเงินจาก Japan Fund for Poverty Reduction
        ผลิตภัณฑ์การให้ความรู้ทางภาษีแบบดิจิทัลนี้
        จัดทำขึ้นเพื่อวัตถุประสงค์ในการให้ความรู้
        ด้านการวางแผนภาษีสำหรับการวางแผนธุรกิจ
        โดยรวมที่ถูกต้องและเหมาะสมในการประกอบกิจการ
        ให้กับบุคคลทั่วไปและผู้ประกอบการเท่านั้น <br /><br />
        ทั้งนี้ กรมสรรพากรและธนาคารพัฒนาเอเชียไม่มีการ
        เก็บข้อมูลส่วนบุคคลหรือข้อมูลตัวเลขจากการคำนวณ
        และไม่มีส่วนรับผิดชอบและความผูกพันตามกฎหมาย
        หากมีการนำผลการคำนวณไปใช้อ้างอิงหรือนำไปใช้ในการยื่นแบบแสดงรายการภาษีกับกรมสรรพากร
        <br /><br />
      </div>

      <div class="eng-topic">
        <div class="topic-wrapper">
          <div class="topic-title">
            <h2>Disclaimer</h2>
          </div>
        </div>

        <div class="content-title">
          This digital tax literacy product ({{ getHostUrl() }}) was developed
          by the Revenue Department with the support of the Asian Development
          Bank (ADB) under a technical assistance on Strengthening Spacialized
          and Semi-Formal Financial Institutions to Support Financial
          Inclusion(financed by the Japan Fund for Poverty Reduction), extended
          to Thailand's Ministry of Finance. In partnership between the Revenue
          Department and ADB, this product has been designed for educational
          purpose and contains no legal authority. <br /><br />The information
          contained in this product is solely as a resource for users without
          any form of assurance. The Revenue Department and ADB specifically do
          not make any warranties or representations as to the accuracy or
          completeness of any such materials, and assume no responsibility for
          any liabilities arising from the use and/or reference of the
          product.<br /><br />
        </div>
      </div>
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/disclaimer.png";

export default {
  name: "Disclaimer",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goBack() {
      const hasHistory = window.history.length > 2;
      hasHistory ? this.$router.go(-1) : this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.content-title {
  color: #393d43;
}

.eng-topic .topic-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: unset;
}

.topic-title {
  width: 100%;
  display: flex;
  border-bottom: 1px solid #acb1bf;
  margin-bottom: 16px;
}
</style>
